import { render, staticRenderFns } from "./PersonTile.vue?vue&type=template&id=dd22d0fa&scoped=true"
import script from "./PersonTile.vue?vue&type=script&lang=js"
export * from "./PersonTile.vue?vue&type=script&lang=js"
import style0 from "./PersonTile.vue?vue&type=style&index=0&id=dd22d0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd22d0fa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PersonTile.vue
// module id = 282
// module chunks = 0